export default __webpack_public_path__ + "static/2238-3f4bb3abefd90a45045f8f4c15f86c2c.gif";